<div class="col th-p newNotification">
  <div class="contents is-marginless">
    <div class="scroll-bar">
      <div class="column">
        <div class="columns">
          <div class="column is-half is-offset-one-quarter">
            <div class="columns new-chat mar-top15">
              <div class="column">
                <div class="card">
                  <div class="card-content">
                    <div class="content form-style">
                      <h3>Notification</h3>

                      <!-- <form [formGroup]="notificationForm" (ngSubmit)="createPost(notificationForm.value)"> -->
                      <form [formGroup]="notificationForm">
                        <div class="columns">
                          <div class="column">
                            <div
                              class="field post-attach-file"
                              style="margin-bottom: 1.75rem"
                            >
                              <label
                                class="label is-tooltip tooltip is-tooltip-multiline"
                                data-tooltip="Only upload PNG, JPEG, JPG, MP4"
                                >Attachment File
                                <i
                                  class="fa fa-info-circle mar-5-0"
                                  aria-hidden="true"
                                ></i>
                              </label>
                              <div class="control profile-img">
                                @if (!preUploadedFile) {
                                <div>
                                  <img
                                    [src]="
                                      '../../../assets/images/empty-state-attach.png'
                                    "
                                  />
                                </div>
                                } @if (preUploadedFile &&
                                preUploadedFile.file_path) {
                                <div>
                                  @if (preUploadedFile.file_type === 'image') {
                                  <img
                                    [src]="
                                      preProfileUrl + preUploadedFile.file_path
                                    "
                                  />
                                  } @if (preUploadedFile?.file_type ==='video')
                                  {
                                  <video
                                    controls
                                    controlsList="nodownload"
                                    style="width: 185px"
                                  >
                                    <source
                                      [src]="
                                        preProfileUrl +
                                        preUploadedFile.temp_file_name
                                      "
                                      type="video/mp4"
                                    />
                                  </video>
                                  }
                                </div>
                                }

                                <span
                                  class="img-options"
                                  [style.background-color]="
                                    preUploadedFile ? 'red' : ''
                                  "
                                >
                                  <div class="dropdown is-hoverable">
                                    @if (!preUploadedFile) {
                                    <div class="dropdown-trigger">
                                      <i
                                        class="fa fa-paperclip"
                                        (click)="fileInput.click()"
                                      ></i>
                                    </div>
                                    } @if (preUploadedFile) {
                                    <div class="dropdown-trigger">
                                      <i
                                        class="fa fa-trash"
                                        (click)="removeSelectedFile()"
                                      ></i>
                                    </div>
                                    }
                                    <div
                                      class="dropdown-menu"
                                      id="dropdown-menu4"
                                      role="menu"
                                    >
                                      <div class="dropdown-content">
                                        @if (!preUploadedFile) {
                                        <a class="dropdown-item">
                                          <label class="file-label">
                                            <span class="file-label"
                                              >Add File or Image</span
                                            >
                                          </label>
                                        </a>
                                        } @if (preUploadedFile) {
                                        <a class="dropdown-item">
                                          <label for="file-label">
                                            <span
                                              class="file-label"
                                              (click)="removeSelectedFile()"
                                              >Remove File or Image</span
                                            >
                                          </label>
                                        </a>
                                        }
                                      </div>
                                    </div>
                                    <input
                                      type="file"
                                      name="msg-file"
                                      style="display: none"
                                      (change)="onFileChange($event)"
                                      #fileInput
                                      accept=".jpg, .jpeg, .png, .mp4"
                                    />
                                  </div>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column">
                            <div class="field">
                              <label class="label"
                                >Title
                                <span class="required">*</span>
                              </label>
                              <div class="control">
                                <input
                                  class="input"
                                  type="text"
                                  placeholder="Title"
                                  formControlName="post_name"
                                  maxlength="255"
                                />
                                <form-validation
                                  [control]="
                                    notificationForm.controls.post_name
                                  "
                                ></form-validation>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column">
                            <div class="field">
                              <label class="label">Message (optional)</label>
                              <div class="control">
                                <textarea
                                  class="textarea"
                                  placeholder="Message"
                                  rows="1"
                                  formControlName="sub_post_name"
                                  maxlength="255"
                                ></textarea>
                                @if (notificationForm.controls.sub_post_name) {
                                <p class="help is-danger">
                                  Message length must be less than 255
                                  characters
                                </p>
                                }
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="columns">
                          <div class="column">
                            <div class="field">
                              <label
                                class="has-tooltip-bottom is-tooltip-multiline"
                                placement="left"
                                >Notification Type
                                <span class="required">*</span>
                                <!-- <a class="is-tooltip tooltip is-tooltip-multiline" data-html="true" data-tooltip="Standard - Users will be notified based on their preferences, Emergency - Users will be notified through all channels email, SMS, app notification irrespective of their preferences">
                                <i class="fa fa-info-circle mar-5-0"></i>
                              </a> -->
                              </label>
                              <div class="control">
                                <label
                                  class="radio has-tooltip-bottom"
                                  data-tooltip="Standard - Users will be notified based on their preferences"
                                >
                                  <input
                                    type="radio"
                                    value="normal"
                                    name="post_priority"
                                    formControlName="post_priority"
                                  />
                                  Standard
                                </label>
                                <label
                                  class="radio has-tooltip-bottom"
                                  data-tooltip="Emergency - Users will be notified through all channels email, SMS, app notification irrespective of their preferences"
                                >
                                  <input
                                    type="radio"
                                    value="high"
                                    name="post_priority"
                                    formControlName="post_priority"
                                  />
                                  Emergency
                                </label>
                                <form-validation
                                  [control]="
                                    notificationForm.controls.post_priority
                                  "
                                ></form-validation>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="columns">
                          <div class="column">
                            <div class="field">
                              <label class="label"
                                >Select Users
                                <span class="required">*</span>
                              </label>
                              <div class="tabs is-boxed mar-0">
                                <ul>
                                  <!-- <li [ngClass]="{'is-active':tabName == 'groups'}" (click)="tabName='groups'">
                                <a><span><i class="fa fa-users"></i> Groups</span></a>
                              </li> -->
                                  <li
                                    [ngClass]="{
                                      'is-active': tabName == 'users'
                                    }"
                                    (click)="tabName = 'users'"
                                  >
                                    <a>
                                      <span>
                                        <i class="pi pi-user"></i> Users</span
                                      >
                                    </a>
                                  </li>
                                  <!-- <li>
                                <a><span><i class="fa fa-slack"></i> Slack</span></a>
                              </li>
                              <li>
                                <a><span><i class="fa fa-file-text"></i> Pagerduty</span></a>
                              </li> -->
                                </ul>
                              </div>

                              @if (tabName=='users') {
                              <div class="columns userList">
                                <div class="column">
                                  <div
                                    class="field pos-relative scroll-bar"
                                    infinite-scroll
                                    [infiniteScrollDistance]="
                                      modalScrollDistance
                                    "
                                    [infiniteScrollThrottle]="
                                      modalScrollThrottle
                                    "
                                    [scrollWindow]="false"
                                    (scrolled)="fetchNextUserList()"
                                  >
                                    <div class="panel-block">
                                      <div
                                        class="control has-icons-left has-icons-right"
                                      >
                                        <input
                                          class="input is-small"
                                          type="text"
                                          [(ngModel)]="search"
                                          [ngModelOptions]="{
                                            standalone: true
                                          }"
                                          placeholder="search"
                                          (keyup)="searchInList.next($event)"
                                        />
                                        <span class="icon is-small is-left">
                                          <i class="fa fa-search"></i>
                                        </span>
                                        <span
                                          class="icon is-small is-right"
                                          (click)="cancelUserSearch()"
                                        >
                                          <i class="fa fa-close"></i>
                                        </span>
                                      </div>
                                    </div>
                                    <div class="panel">
                                      @for (user of listOfUsers; track user; let
                                      i = $index) {
                                      <label
                                        class="panel-block pos-relative"
                                        [ngClass]="{
                                          'active-bg':
                                            userIdList.indexOf(user.user_id) >
                                            -1
                                        }"
                                        (click)="selectedUser(user.user_id)"
                                      >
                                        @if (!user.user_icon) {
                                        <empty-uname
                                          [userName]="user.full_name"
                                          [liProfile]="true"
                                        ></empty-uname>
                                        } @if (user.user_icon) {
                                        <img
                                          [src]="profileUrl + user.user_icon"
                                          class="image is-48x48"
                                        />
                                        }
                                        <div class="mar-0-10">
                                          <span class="display-b">
                                            {{ user.full_name }}</span
                                          >
                                        </div>
                                        <span class="icon-align">
                                          @if (userIdList.indexOf(user.user_id)
                                          > -1) {
                                          <i class="fa fa-check mar-0-5"></i>
                                          } @if (user.enable_sms_channel) {
                                          <i class="fa fa-phone mar-0-5"></i>
                                          } @if (user.enable_email_channel) {
                                          <i
                                            class="fa fa-envelope-o mar-0-5"
                                          ></i>
                                          } @if (user.voice_call) {
                                          <i class="fa fa-mobile mar-0-5"></i>
                                          }
                                        </span>
                                      </label>
                                      }
                                      <pagination-loader
                                        [showFetchLoader]="showPaginateSpinner"
                                      ></pagination-loader>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              }
                            </div>
                          </div>
                        </div>

                        <div class="columns is-clearfix">
                          <div class="column">
                            <div class="has-text-right">
                              <button
                                type="button"
                                class="button mar-0-5"
                                [routerLink]="['/channels']"
                                (click)="closeNotifyResView()"
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                class="button is-link"
                                [disabled]="!notificationForm.valid"
                                (click)="createPost(notificationForm.value)"
                              >
                                Send
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <!-- card -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (showNotfication) {
<div class="column">
  <div class="columns">
    <div class="column is-half is-offset-one-quarter">
      <div class="columns new-chat mar-top15">
        <div class="column">
          <div class="card">
            <div class="card-content">
              <div class="content">
                <h3>Notification</h3>
                <p>372 users on the notification</p>
                <br />
                <p>
                  <strong>
                    <i class="fa fa-commenting" aria-hidden="true"></i>140
                    Text</strong
                  >
                  &nbsp;&nbsp;
                  <strong>
                    <i class="fa fa-mobile" aria-hidden="true"></i> 134
                    Mobile</strong
                  >
                  &nbsp;&nbsp;
                  <strong>
                    <i class="fa fa-envelope" aria-hidden="true"></i>98
                    Emails</strong
                  >
                  &nbsp;&nbsp;
                </p>
                <br />
                <p>
                  Check real time update in the information section "
                  <span class="button">
                    <i class="fa fa-info" aria-hidden="true"></i> </span
                  >"
                </p>
                <div class="columns is-clearfix">
                  <div class="column">
                    <div class="has-text-right">
                      <button
                        type="button"
                        [routerLink]="['/notifications']"
                        class="button mar-0-5"
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
                <!-- field -->
              </div>
            </div>
          </div>
          <!-- card -->
        </div>
      </div>
    </div>
  </div>
</div>
}
